export default __webpack_public_path__ + "static/media/resumeReportIcon.936ebd5f.svg";